import styled from 'styled-components';

export const MainNavigationWrapper = styled.div<{ $zIndex?: number }>`
    position: absolute;
    z-index: ${({ $zIndex }) => ($zIndex ? $zIndex : 9)};
    top: 0;
    right: 0;
    left: 0;
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`;
